export const prefecture = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
] as const;

export const prefectureABC = {
  北海道: 'HOKKAIDO',
  青森県: 'AOMORI',
  岩手県: 'IWATE',
  宮城県: 'MIYAGI',
  秋田県: 'AKITA',
  山形県: 'YAMAGATA',
  福島県: 'FUKUSHIMA',
  茨城県: 'IBARAKI',
  栃木県: 'TOCHIGI',
  群馬県: 'GUNMA',
  埼玉県: 'SAITAMA',
  千葉県: 'CHIBA',
  東京都: 'TOKYO',
  神奈川県: 'KANAGAWA',
  新潟県: 'NIIGATA',
  富山県: 'TOYAMA',
  石川県: 'ISHIKAWA',
  福井県: 'FUKUI',
  山梨県: 'YAMANASHI',
  長野県: 'NAGANO',
  岐阜県: 'GIFU',
  静岡県: 'SHIZUOKA',
  愛知県: 'AICHI',
  三重県: 'MIE',
  滋賀県: 'SHIGA',
  京都府: 'KYOUTO',
  大阪府: 'OSAKA',
  兵庫県: 'HYOUGO',
  奈良県: 'NARA',
  和歌山県: 'WAKAYAMA',
  鳥取県: 'TOTTORI',
  島根県: 'SHIMANE',
  岡山県: 'OKAYAMA',
  広島県: 'HIROSHIMA',
  山口県: 'YAMAGUCHI',
  徳島県: 'TOKUSHIMA',
  香川県: 'KAGAWA',
  愛媛県: 'EHIME',
  高知県: 'KOUCHI',
  福岡県: 'FUKUOKA',
  佐賀県: 'SAGA',
  長崎県: 'NAGASAKI',
  熊本県: 'KUMAMOTO',
  大分県: 'OOITA',
  宮崎県: 'MIYAZAKI',
  鹿児島県: 'KAGOSHIMA',
  沖縄県: 'OKINAWA',
};

export const hint: {
  [pref: string]: [number, number, string, 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8];
} = {
  北海道: [538, 83424, 's', 1],
  宮城県: [233, 7282, 's', 1],
  福島県: [191, 13784, 'f', 1],
  青森県: [131, 9646, 'a', 1],
  岩手県: [128, 15275, 'm', 1],
  山形県: [112, 9323, 'y', 1],
  秋田県: [102, 11638, 'a', 1],
  東京都: [1352, 2191, 's', 2],
  神奈川県: [913, 2416, 'y', 2],
  埼玉県: [727, 3798, 's', 2],
  千葉県: [622, 5158, 'c', 2],
  茨城県: [292, 6097, 'm', 2],
  群馬県: [197, 6362, 'm', 2],
  栃木県: [197, 6408, 'u', 2],
  長野県: [210, 13562, 'n', 2],
  山梨県: [83, 4465, 'k', 2],
  新潟県: [230, 12584, 'n', 2],
  愛知県: [748, 5172, 'n', 3],
  岐阜県: [203, 10621, 'g', 3],
  静岡県: [370, 7777, 's', 3],
  三重県: [182, 5774, 't', 3],
  石川県: [115, 4186, 'k', 4],
  富山県: [107, 4248, 't', 4],
  福井県: [79, 4190, 'f', 4],
  大阪府: [884, 1905, 'o', 5],
  兵庫県: [553, 8401, 'k', 5],
  京都府: [261, 4612, 'k', 5],
  滋賀県: [141, 4017, 'o', 5],
  奈良県: [136, 3691, 'n', 5],
  和歌山県: [96, 4725, 'w', 5],
  広島県: [284, 8479, 'h', 6],
  岡山県: [192, 7115, 'o', 6],
  山口県: [140, 6112, 'y', 6],
  鳥取県: [57, 3507, 't', 6],
  島根県: [69, 6708, 'm', 6],
  香川県: [98, 187, 't', 7],
  愛媛県: [139, 5676, 'm', 7],
  徳島県: [76, 4147, 't', 7],
  高知県: [73, 7104, 'k', 7],
  福岡県: [510, 4986, 'f', 8],
  鹿児島県: [165, 9187, 'k', 8],
  熊本県: [179, 7409, 'k', 8],
  長崎県: [138, 4132, 'n', 8],
  宮崎県: [110, 7735, 'm', 8],
  大分県: [117, 6341, 'o', 8],
  佐賀県: [83, 2441, 's', 8],
  沖縄県: [143, 2281, 'n', 8],
};

export const area = {
  1: '東北または北海道',
  2: '関東甲信越地方',
  3: '東海地方',
  4: '北陸地方',
  5: '近畿地方',
  6: '中国地方',
  7: '四国地方',
  8: '九州または沖縄',
};
